// export const baseUrl = process.env.API_URL || 'http://localhost:3000/'
const apiUrl = (process.env.API_URL || 'https://api.yteach.com/').trim()
export const baseUrl = apiUrl
// export const baseUrl = 'http://localhost:3000/' || 'https://staging.api.yteach.com/'

export const fixAutofillInput = `if (this.hasAttribute('readonly')) {
                                    this.removeAttribute('readonly');
                                    // fix for mobile safari to show virtual keyboard
                                    this.blur();    this.focus();
                                }`



// WEBPACK FOOTER //
// ./src/config.js